export const APP_VERSION = "1.0.3";
export const PROJECT_TTL_MS = 7 * 24 * 60 * 60 * 1000;
export const OUTPUT_TTL_MS = 24 * 60 * 60 * 1000;

export type PlaybackRate = 0.5 | 0.75 | 1 | 1.25 | 1.5 | 2;

export type AudioMetadata = {
  fileName: string;
  fileSize: number;
  fileLastModified: number;
  mimeType: string;
  codec: string;
  sampleRate: number;
  channels: number;
  durationFrames: number;
  trackStartSeconds: number;
};

export type ViewportState = {
  centerFrame: number;
  visibleFrames: number;
};

export type EditingProject = AudioMetadata & {
  id: string;
  startFrame: number;
  endFrame: number;
  playheadFrame: number;
  playbackRate: PlaybackRate;
  title: string;
  suppressClicks: boolean;
  viewport: ViewportState;
  createdAt: number;
  updatedAt: number;
  sourceExpiresAt: number;
};

export type Boundary = "start" | "end";

export type TrimSnapshot = {
  startFrame: number;
  endFrame: number;
};

export type ExportRecord = {
  id: string;
  projectId: string;
  fileName: string;
  opfsName: string;
  createdAt: number;
  expiresAt: number;
  size: number;
  durationFrames: number;
  mimeType: string;
};

export type DiagnosticsRecord = {
  inputCodec?: string;
  sampleRate?: number;
  channels?: number;
  inputDurationSeconds?: number;
  overviewSeconds?: number;
  detailSeconds?: number;
  outputCodec?: string;
  outputDurationSeconds?: number;
  exportSeconds?: number;
  outputBytes?: number;
  lastError?: string;
};
